import { UPDATE_ABOUT } from "../constants";

const initialState = null;

export const setAboutData = (data) => ({
    type: UPDATE_ABOUT,
    data,
});

export const about = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ABOUT:
            return action.data;
        default:
            return state;
    }
};
